import styled from "styled-components";

interface StyledDialogFooterProps {}

export const StyledDialogFooter = styled.footer<StyledDialogFooterProps>`
  box-sizing: border-box;
  padding: 0 1.6rem 1.6rem 1.6rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.8rem;
`;
